import {ValidationError} from "../ValidationTypes";
import {validateTrusts} from "../distribution/TrustValidator";
import {validateCharities} from "../distribution/CharityValidator";
import {validateOutrights} from "../distribution/OutrightValidator";
import {filterCharities, filterOutrights, filterTrusts} from "../ValidationUtils";
import {Distribution} from "../../model/EstateFlowchartTypes";

export const validateBeneficiariesAtFirstDeath = (distributions: Distribution[], enableEstateFlowchartMVPRelease: boolean): ValidationError[] => {
    let validationErrors: ValidationError[] = [];

    if (distributions && distributions.length > 0) {
        validationErrors = validationErrors.concat(validateTrusts(filterTrusts(distributions)));
        validationErrors = validationErrors.concat(validateCharities(filterCharities(distributions), enableEstateFlowchartMVPRelease));
        validationErrors = validationErrors.concat(validateOutrights(filterOutrights(distributions)));
    }

    return validationErrors;
}